import UserApi from '../classes/api/User';
import ValidationError from "../classes/ValidationError";
import dateFormat from 'dateformat';

export default class User {
    get company_id() {
        return this._company_id;
    }

    set company_id(value) {
        this._company_id = value;
    }
    get filiationId() {
        return this._filiationId;
    }

    set filiationId(value) {
        this._filiationId = value;
    }
    get postId() {
        return this._postId;
    }

    set postId(value) {
        this._postId = value;
    }
    get comment() {
        return this._comment;
    }

    set comment(value) {
        this._comment = value;
    }
    get email() {
        return this._email;
    }

    set email(value) {
        this._email = value;
    }
    get login() {
        return this._login;
    }

    set login(value) {
        this._login = value;
    }
    get role() {
        return this._role;
    }

    set role(value) {
        this._role = value;
    }
    get birthday() {
        if (!this._birthday) {
            return '';
        }
        return dateFormat((new Date()).setTime(this._birthday * 1000), 'yyyy-mm-dd');
    }
    set birthday(value) {
        if (value instanceof Number) {
            this._birthday = value;
        }
        this._birthday = (new Date(dateFormat((new Date(value))))).getTime() / 1000;
    }
    get birthdayTimestamp() {
        return this._birthday;
    }
    get phone() {
        return this._phone;
    }

    set phone(value) {
        this._phone = value;
    }

    get avatar() {
        return this._avatar;
    }
    set avatar(value) {
        this._avatar = value;
    }

    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }

    get firstName() {
        return this._firstName;
    }
    set firstName(value) {
        this._firstName = value;
    }
    get lastName() {
        return this._lastName;
    }
    set lastName(value) {
        this._lastName = value;
    }
    get fullName() {
        let pieces = [];
        if (this.firstName) {
            pieces.push(this.firstName);
        }
        if (this.lastName) {
            pieces.push(this.lastName);
        }
        return pieces.join(' ');
    }

    get id() {
        return this._id;
    }

    static STATUS_ACTIVE = 10;
    static STATUS_DISABLED = 20;

    constructor (config) {
        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            post_id: this.postId,
            name: this.firstName,
            last_name: this.lastName,
            role: this.role,
            login: this.login,
            email: this.email,
            comment: this.comment,
            company_id: this.company_id,
            filiation_id: this.filiationId,
            phone: this.phone,
            birthday: this.birthdayTimestamp,
            status: this.status === true ? 10 : 20
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            postId: data.post_id,
            firstName: data.name,
            lastName: data.last_name,
            role: data.role,
            filiationId: data.filiation_id,
            login: data.login,
            email: data.email,
            comment: data.comment,
            company_id: data._company_id,
            phone: data.phone,
            birthday: data.birthday,
            status: data.status === this.STATUS_ACTIVE,
            avatar: {
                image: data.avatar,
                small: data.avatar_small,
            },
        };
    }

    static getList(page = 1, perPage = 10) {
        return UserApi.getList(page, perPage).then((response) => {
            let data = [];
            for (let user of response.data) {
                data.push(new this(this.toResponse(user)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return UserApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }

    static getMe() {
        return UserApi.getMe().then(({data}) => {
            return new this(this.toResponse(data));
        });
    }

    static getRoles() {
        return {
            developer: ['any', 'manager', 'admin', 'developer'],
            admin: ['any', 'manager', 'admin'],
            manager: ['any', 'manager'],
        };
    }

    can(role) {
        if (!role) {
            return true;
        }

        const roles = User.getRoles();

        return roles[this.role] && roles[this.role].some(uRole => uRole === role);
    }

    add(password) {
        let request = this.toRequest();
        request.password = password;
        return UserApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new User(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return UserApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    updatePassword(password, repeat) {
        return UserApi.changePassword(this.id, password, repeat).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        });
    }

    updateImage(file) {
        return UserApi.updateAvatar(this.id, file).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.avatar.image = data.avatar;
            this.avatar.small = data.avatar_small;
            return true;
        });
    }
}